/**
 * A file for defining the colors used in the project.
 */
const COLORS = {
  // From Official hack website
  // https://github.com/hack4impact/chapter-website-template/blob/main/public/style.css
  primaryBlue: '#0069ca',
  secondarySeafoam: '#80d2c8',
  gray: '#657788',
  primaryDark: '#172a3a', // Dark Blue
  primaryDark2: '#2e5987', // Dark Blue level 2
  background: '#d7fdff', // Light Light Blue
  accentOrange: '#f2594b',
  black: '#171717', // Black
  white: '#ffffff', // White
  neutral: '#8c8c8c', // Gray
  lightGray: '#ebeff2', // Gray-subsection
  actionBlue: '#155da1', // Action button
  green: '#6BAD6A', // Green
  lightBlue: '#e3f2fd', // Light Blue for cards

  // Other colors:
};
export default COLORS;
